// Valores del enum `type` definido en el payload schema del workflow de Novu
// (Manage workflow schema > Payload schema). No corresponde al `severity` nativo
// de Novu (`SeverityLevelEnum`), que se configura a nivel de workflow y solo
// admite high/medium/low/none.
export enum NovuNotificationType {
  INFO = 'INFO',
  SUCCESS = 'SUCCESS',
  WARNING = 'WARNING',
  ERROR = 'ERROR',
  QUESTION = 'QUESTION',
  ALERT = 'ALERT',
}
